(function() { window.GUID_3a89addc_5580_4cf7_ae1e_f84093718fb2 = { getGuid: function() { return "3a89addc-5580-4cf7-ae1e-f84093718fb2"; } }; })();
var CS;
(function (CS) {
    function GetKeyPressed(e) {
        let key = window.event ? e.keyCode : e.which;
        if (key == 65 && e.ctrlKey) {
            key = CS.Enums.KeyCode.CtlrA;
        }
        return key;
    }
    CS.GetKeyPressed = GetKeyPressed;
})(CS || (CS = {}));

//# sourceMappingURL=cs-keyhelper.js.map
